import {rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';

import {baseTranslateEnumFormatterParams} from 'src/js/lib/raw_rendering/base_translate_enum_formatter_params';

export function translateEnumFormatter(
  params: ICellRendererParams,
  services: RenderingServices
) {
  const enumParams = baseTranslateEnumFormatterParams(params);

  const label = rawRenderingLib.translatedEnumValueRenderer(
    enumParams,
    services
  );
  return `<span title="${label}">${label}</span>`;
}
